import React, { useState } from 'react';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';
import { FixedSizeList } from 'react-window';

const theme = createTheme({
    typography: { htmlFontSize: 10 },
    overrides: {
        MuiListItem: {
            root: {
                height: '2.5rem'
            }
        },
        MuiTypography: {
            body1: {
                fontSize: '1.3rem',
                whiteSpace: 'nowrap'
            }
        }
    }
});

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 400,
        backgroundColor: '#f0f5ff',
    },
}));


const ItemsList = ({ articles, selectedArticle, setSelectedArticle }) => {
    const classes = useStyles()

    return (
        <ThemeProvider theme={theme}>
            <List component="nav" className={classes.root} aria-label="contacts">
                {articles.map(({ id, name }) => {
                    return (
                        <ListItem key={id} button onClick={() => setSelectedArticle(id.toString())} selected={id.toString() == selectedArticle}>
                            <ListItemText primary={name} />
                        </ListItem>
                    );
                })}
            </List>
        </ThemeProvider>
    );
}

export default ItemsList